// #Fase2-B2 — El temporizador también cubre navegadores que no llaman al callback.
export function captureLocation(geolocation = navigator.geolocation) {
  return new Promise((resolve) => {
    let finished = false;
    const finish = (value) => {
      if (finished) return;
      finished = true;
      clearTimeout(timer);
      resolve(value);
    };
    const timer = setTimeout(() => finish(null), 8000);
    if (!geolocation) return finish(null);
    try {
      geolocation.getCurrentPosition(({ coords }) => {
        const location = {
          lat: coords.latitude, lng: coords.longitude, accuracy_m: coords.accuracy,
          source: 'gps', captured_at: new Date().toISOString(),
        };
        finish(validPoint(location) ? location : null);
      }, () => finish(null), { timeout: 8000, maximumAge: 0, enableHighAccuracy: false });
    } catch {
      finish(null);
    }
  });
}

export function validPoint(point) {
  return typeof point.lat === 'number' && Number.isFinite(point.lat) && Math.abs(point.lat) <= 90 &&
    typeof point.lng === 'number' && Number.isFinite(point.lng) && Math.abs(point.lng) <= 180;
}

// #Fase2-F4 — Un objeto vacío o sin fuente no acredita ubicación.
export function validGeo(location) {
  return !!location && validPoint(location) && !!location.source && location.source !== 'none';
}

export function formatAccuracy(accuracy) {
  return Number.isFinite(accuracy) && accuracy >= 0 ? `±${Math.round(accuracy)} m` : 'Sin precisión';
}

export function evidenceStamp(evidence = {}) {
  const date = new Date(evidence.captured_at || evidence.client_captured_at || evidence.geo?.captured_at || evidence.location?.captured_at || '');
  const time = Number.isNaN(date.getTime()) ? 'Sin fecha y hora' : date.toLocaleString('es-MX', {
    timeZone: 'America/Mexico_City', day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
  }).replace(',', '');
  return [[evidence.zone?.label, evidence.zone?.detail].filter(Boolean).join(' — ') || 'Sin zona',
    formatAccuracy((evidence.geo || evidence.location)?.accuracy_m), time,
    evidence.capture_source === 'gallery' ? '(galería)' : null].filter(Boolean).join(' · ');
}

export function uniqueEvidence(item = {}) {
  const docs = (Array.isArray(item.evidence) ? item.evidence : []).filter(Boolean)
    .map(e => typeof e === 'string' ? { file_url: e } : e);
  const result = new Map();
  [...docs, ...(item.evidence_urls || []).map(file_url => ({ file_url }))].forEach(e => {
    const url = e.file_url || e.url;
    if (typeof url === 'string' && url && !result.has(url)) result.set(url, { ...e, file_url: url });
  });
  return [...result.values()];
}

// #Fase2-A7 — La fecha evita presentar un contacto antiguo como si fuera de hoy.
export function devicePendingMessage(evaluation, now = new Date()) {
  const pending = (evaluation?.device_pending || []).filter((entry) => entry.pending_count > 0);
  if (!pending.length) return '';
  const count = pending.reduce((sum, entry) => sum + Number(entry.pending_count), 0);
  const dates = pending.map((entry) => Date.parse(entry.last_contact_at)).filter(Number.isFinite);
  let time = 'desconocido';
  if (dates.length) {
    const contact = new Date(Math.max(...dates));
    const options = { hour: '2-digit', minute: '2-digit' };
    time = contact.toLocaleTimeString('es-MX', options);
    if (contact.toDateString() !== now.toDateString()) {
      time = `${contact.toLocaleDateString('es-MX')} ${time}`;
    }
  }
  const changes = count === 1 ? 'cambio' : 'cambios';
  return `El levantador tiene ${count} ${changes} sin sincronizar (último contacto ${time})`;
}
